import { createContext, useContext, useState, useEffect } from 'react';

const DEFAULT = {
  items: [], totalItems: 0, subtotal: 0,
  addItem: ()=>{}, removeItem: ()=>{}, updateQty: ()=>{}, clearCart: ()=>{},
};

const CartContext = createContext(DEFAULT);

export function CartProvider({ children }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    try { setItems(JSON.parse(localStorage.getItem('aurora_cart') || '[]')); }
    catch { setItems([]); }
  }, []);

  function save(next) {
    setItems(next);
    localStorage.setItem('aurora_cart', JSON.stringify(next));
  }

  function addItem(product) {
    setItems((prev) => {
      const exists = prev.find((i) => i.id === product.id);
      const next   = exists
        ? prev.map((i) => i.id === product.id ? { ...i, qty: i.qty + 1 } : i)
        : [...prev, { ...product, qty: 1 }];
      localStorage.setItem('aurora_cart', JSON.stringify(next));
      return next;
    });
  }

  function removeItem(id) {
    setItems((prev) => {
      const next = prev.filter((i) => i.id !== id);
      localStorage.setItem('aurora_cart', JSON.stringify(next));
      return next;
    });
  }

  function updateQty(id, qty) {
    if (qty < 1) { removeItem(id); return; }
    setItems((prev) => {
      const next = prev.map((i) => i.id === id ? { ...i, qty } : i);
      localStorage.setItem('aurora_cart', JSON.stringify(next));
      return next;
    });
  }

  function clearCart() { save([]); }

  const totalItems = items.reduce((s, i) => s + i.qty, 0);
  const subtotal   = items.reduce((s, i) => s + i.price * i.qty, 0);

  return (
    <CartContext.Provider value={{ items, addItem, removeItem, updateQty, clearCart, totalItems, subtotal }}>
      {children}
    </CartContext.Provider>
  );
}

export function useCart() { return useContext(CartContext); }